import {fetchBaseQuery} from "@reduxjs/toolkit/query";

// Настойки для API
export const apiQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, {getState}) => {
        const {auth: {token}}: any = getState()
        headers.set("Authorization", `Bearer ${token}`)
        return headers
    }
})
